import 'reflect-metadata';
import 'core-js';
import 'classlist.js';
import 'web-animations-js'; 
import 'zone.js';
import 'bootstrap';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UpplmModule } from './app/app.module.browser';
import { environment } from './environments/environment';

console.log(environment.envr);
if (module.hot) {   
    module.hot.accept();
    module.hot.dispose(() => {
        // Before restarting the app, we create a new root element and dispose the old one
        const oldRootElem = document.querySelector('app-root');
        const newRootElem = document.createElement('app-root');
        oldRootElem!.parentNode!.insertBefore(newRootElem, oldRootElem);
        modulePromise.then(appModule => appModule.destroy());
    });
} else {
    console.log("I am Prod");
    enableProdMode();
}
if (!Element.prototype.matches) {
    Element.prototype.matches = (<any>Element.prototype).msMatchesSelector;
}
// Note: @ng-tools/webpack looks for the following expression when performing production
// builds. Don't change how this line looks, otherwise you may break tree-shaking.
const modulePromise = platformBrowserDynamic().bootstrapModule(UpplmModule);
//platformBrowserDynamic().bootstrapModule(UpplmModule);
